import "./ItemsList.scss";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  DataGrid,
  gridFilteredTopLevelRowCountSelector,
  GridFooterContainer,
  gridPageSizeSelector,
  GridPagination,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from "@mui/x-data-grid";
import { useSearchParams } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Pagination from "@mui/material/Pagination";
import { LoadIcon } from "../../icons/LoadIcon/LoadIcon";
import { getPageCount } from "@mui/x-data-grid/hooks/features/pagination/gridPaginationUtils";
import { getColorClassName } from "../../pages/CalendarPage";
/**
 *
 *const headers = [
 { field: 'id', headerName: 'ID', sortable: false, type: 'number'},
 { field: 'firstName', headerName: 'First name', maxWidth: 200, flex: 1, type: 'string' },
 { field: 'lastName', headerName: 'Last name', maxWidth: 200, flex: 1},
 { field: 'age', headerName: 'Age'},
 { field: 'fullName', headerName: 'Full name', sortable: false,flex: 1,
            valueGetter: (params) =>
                `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
 ];

 const items = [
 { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
 { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
 { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
 { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
 { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
 { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
 { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
 { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
 { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
 ];

 *
 * @param items
 * @param headers
 * @param sortHandler
 * @param totalCount
 * @param server
 * @returns {*}
 * @constructor
 */

function ItemsList(
  {
    items = [],
    headers = [],
    totalCount = 100,
    defaultPageSize = 10,
    currentPage = 1,
    getItems = () => {},
    server = false,
    gridId = "data-grid",
    actionResult = {},
    defaultSort = "-id",
    addSearchParam = false,
    disableColumnMenu = true,
    defaultSortModel = false,
  },
  ref,
) {
  useImperativeHandle(ref, () => ({
    load: () => {
      load();
    },
  }));

  const [isLoading, setIsLoading] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sort, setSort] = useState(defaultSort);
  const [filter, setFilter] = useState(null);

  const handlePageModelChange = (params) => {
    setPage(params?.page + 1);
    setPageSize(params.pageSize);
  };

  const handleSortModelChange = (params) => {
    let obj = {};
    let sort = defaultSort;
    if (params.length > 0) {
      obj = params[0];
      sort = (obj.sort === "desc" ? "-" : "") + `${obj.field}`;
      // setSort([`${obj.field}`, obj.sort]);
    }
    setSort(sort);
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState(
    localStorage.getItem("hideColumns")
      ? JSON.parse(localStorage.getItem("hideColumns"))[`${gridId}`] || {}
      : {},
  );

  const handleHideColumns = (newModel) => {
    setColumnVisibilityModel(newModel);
    let data = JSON.parse(localStorage.getItem("hideColumns")) || {};
    data[`${gridId}`] = newModel;
    localStorage.setItem("hideColumns", JSON.stringify(data));
  };

  const load = () => {
    setIsLoading(true);
    let pageOb = { number: page, size: pageSize };
    getItems({ page: pageOb, sort: sort, filter: filter || {} });
  };

  useEffect(() => {
    // setPage(new URLSearchParams(location.search).get("page") || 1);
    setPage(1);
    setSort(defaultSort);
    setFilter({});
  }, [gridId]);

  useEffect(() => {
    if (!filter) {
      setFilter({});
      return;
    }
    if (page > 0 && server) {
      load();
    }
  }, [page, sort, filter, pageSize]);

  useEffect(() => {
    if (!addSearchParam) return;
    if (page > 1) {
      setSearchParams({ page: page });
    } else {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
  }, [page]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [items]);

  const handleBgColor = (params) => {
    const calendar = params?.row?.calendar;
    if (calendar) {
      return (
        getColorClassName(calendar.type) +
        " " +
        " loc-" +
        getColorClassName(calendar.location)
      );
    }
    return "";
  };
  return (
    <div className="items-list">
      {server && (
        <div style={{ height: "30px", marginTop: "-15px" }}>
          {isLoading && <LoadIcon />}
        </div>
      )}

      {!!actionResult.success && <Alert severity="success">Success!</Alert>}
      {!!actionResult.error && (
        <Alert severity="error">{actionResult.error}</Alert>
      )}

      <div
        style={{ display: "flex", height: "100%", opacity: isLoading ? 1 : 1 }}
      >
        <div style={{ flexGrow: 1 }}>
          <DataGrid
            autoHeight
            rows={items}
            columns={headers}
            rowCount={totalCount}
            pageSizeOptions={[2, 5, 10, 20, 50, 100]}
            onPaginationModelChange={handlePageModelChange}
            // pagination
            page={currentPage - 1}
            paginationMode={server ? "server" : "client"}
            sortingMode={server ? "server" : "client"}
            onSortModelChange={handleSortModelChange}
            getRowHeight={() => "auto"}
            disableColumnFilter
            disableColumnMenu={disableColumnMenu}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleHideColumns}
            slots={{
              footer: CustomFooter,
            }}
            disableSelectionOnClick
            initialState={{
              pagination: { paginationModel: { pageSize: pageSize } },
              sorting: {
                sortModel: [defaultSortModel ?? {}],
              },
            }}
            hideFooter={totalCount === pageSize}
            columnHeaderHeight={35}
            getRowClassName={handleBgColor}
            sx={{
              ".MuiDataGrid-sortIcon": {
                width: "12px",
                height: "12px",
              },
              ".MuiIconButton-root": {
                padding: "2px",
              },

              ".MuiDataGrid-iconSeparator": {
                display: "none",
              },
              ".MuiDataGrid-columnHeaderTitle": {
                overflow: "visible",
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}

function PaginationActions({ page, onPageChange, className }) {
  const apiRef = useGridApiContext();
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const visibleTopLevelRowCount = useGridSelector(
    apiRef,
    gridFilteredTopLevelRowCountSelector,
  );
  const rootProps = useGridRootProps();
  const pageCount = getPageCount(
    rootProps.rowCount ?? visibleTopLevelRowCount,
    pageSize,
  );

  return (
    <>
      {pageCount > 0 && (
        <Pagination
          className={className}
          count={pageCount}
          page={page + 1}
          onChange={(event, newPage) => {
            onPageChange(event, newPage - 1);
          }}
        />
      )}
    </>
  );
}

function CustomPagination(props) {
  return <GridPagination ActionsComponent={PaginationActions} {...props} />;
}

function CustomFooter(props) {
  return (
    <GridFooterContainer>
      <CustomPagination {...props} />
    </GridFooterContainer>
  );
}

export default forwardRef(ItemsList);
